import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';
import { Pagination } from 'common/components/Table/CommonTableStyles';
import { CONTENT_TYPE, SORT_ORDER } from 'common/constants';
import { LOCATION_OPTIONS } from 'common/constants/AISimulationConstants';
import { getHeader } from 'common/utils/utilFunctions';

import { APIResponse } from 'features/AiSimulation/api/type-def';

import {
	IWorkflowDataResponse,
	UpdateTableResponse,
	UpdateTableRequestType,
	IStatusBarCountResponse,
	ITaskResponseList,
	IRegDetailsResponse,
	IStatusDetails,
	IFilterValues,
	ITaskTabResponse,
	IMappedTaskData,
	IUser,
	IGetStatusBarCount,
	IUpdateTaskFlow,
	IAddUserToTaskFlow,
	IGetRegulaionMappingParams,
	IGetRegulaionMappingResp,
	IQueryCriteria,
	IGetObligationRelationshipParams,
	IObligationCard,
} from './type-def';

const {
	REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL: BASE_URL,
	REACT_APP_REG_INVENTORY_DOMAIN_SERVICE_URL: REG_INV_URL,
	REACT_APP_USER_SERVICE_URL,
	REACT_APP_GEN_AI_SERVICE_URL: genAiServiceUrl,
} = process.env;

const { JSON } = CONTENT_TYPE;

const { HORIZON_SCANNING } = LOCATION_OPTIONS;

export async function getUpdatesTableData(
	payload: UpdateTableRequestType,
	params: Pagination,
) {
	const sortKey = params?.sortKey ? params?.sortKey : 'reviewByDate';
	const sortDirection = params?.sortDirection ? params?.sortDirection : 'desc';
	const sort =
		sortKey !== '' && payload.searchText.length === 0
			? `${sortKey},${sortDirection}`
			: `${sortKey}`;
	const url = `${BASE_URL}/elastic-search/regulation/insights/search?pageNumber=${params.pageNumber}&pageSize=${params.pageSize}&sort=${sort}`;
	const res = await apiWrapper.post<UpdateTableResponse, IAPIErrorContent>(
		url,
		payload,
	);
	return res;
}
export const getStatusBarCount = async (data: IGetStatusBarCount) => {
	const url = `${BASE_URL}/elastic-search/regulation/insight/count`;
	const resp = await apiWrapper.post<
		IStatusBarCountResponse[],
		IAPIErrorContent
	>(url, data);
	return resp;
};
export const getListOfUsers = async (searchText?: string) => {
	const { ASCENDING } = SORT_ORDER;
	const url = `${REACT_APP_USER_SERVICE_URL}/users/search?filterText=${
		searchText || ''
	}&sortBy=&sortOrder=${ASCENDING}`;
	const resp = await apiWrapper.get<IUser[], IAPIErrorContent>(url);
	return resp;
};

export const addUserToTaskFlow = async (data: IAddUserToTaskFlow) => {
	const url = `${BASE_URL}/task-manager/task`;
	const resp = await apiWrapper.post<
		ITaskResponseList[] | ITaskResponseList,
		IAPIErrorContent
	>(url, data);
	return resp;
};

export const updateTaskWorkflow = async (data: IUpdateTaskFlow) => {
	const url = `${BASE_URL}/task-manager/task`;
	const resp = await apiWrapper.put<ITaskResponseList[], IAPIErrorContent>(
		url,
		data,
	);
	return resp;
};

export const putApplicability = async (data: IStatusDetails, id: string) => {
	const url = `${BASE_URL}/horizon/regulation/insight/${id}/status`;
	const resp = await apiWrapper.put<IRegDetailsResponse, IAPIErrorContent>(
		url,
		data,
	);
	return resp;
};

export const getRegSummaryDetailsData = async (subPartId: string) => {
	const url = `${BASE_URL}/horizon/regulation/insight/${subPartId}`;
	const resp = await apiWrapper.get<IRegDetailsResponse, IAPIErrorContent>(
		url,
		{},
		JSON,
	);
	return resp;
};

export const updateAISumamry = async (subPartId: string, data: string) => {
	const url = `${BASE_URL}/horizon/regulation/insight/${subPartId}/summary`;
	const resp = await apiWrapper.put<IRegDetailsResponse, IAPIErrorContent>(
		url,
		{ aiSummary: data },
		JSON,
	);
	return resp;
};

export const getWorkflowData = async (id: string) => {
	const url = `${BASE_URL}/task-manager/task/horizon/${id}`;
	const resp = await apiWrapper.get<IWorkflowDataResponse[], IAPIErrorContent>(
		url,
		{},
		JSON,
	);
	return resp;
};

export const getFilterValues = async (id: string) => {
	const url = `${process.env.REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/task-manager/task/filter-values?userId=${id}`;
	const resp = await apiWrapper.get<IFilterValues, IAPIErrorContent>(url);
	return resp;
};

export const getRelationshipMappingData = async (
	id: string,
	params: IGetRegulaionMappingParams,
) => {
	const sort =
		params?.sortParam !== '' ? `${params?.sortParam},${params?.sortOrder}` : '';
	const url = `${BASE_URL}/relation-mapping/relationship?parentObjectId=${id}&parentObjectType=Horizon&page=${
		params.pageNumber || 0
	}&size=${params.pageSize || 12}&sort=${sort}&filterText=${params.searchText}`;
	const resp = await apiWrapper.get<IGetRegulaionMappingResp, IAPIErrorContent>(
		url,
		{},
	);
	return resp;
};

export const getRelationshipForObligation = async (
	citationGroupId: string,
	horizonRegulationId: string,
	params: IGetRegulaionMappingParams,
) => {
	const sort =
		params?.sortParam !== '' ? `${params?.sortParam},${params?.sortOrder}` : '';
	const url = `${REG_INV_URL}/horizon/relationships?citationGroupId=${citationGroupId}&horizonRegulationId=${horizonRegulationId}&page=${
		params.pageNumber || 0
	}&size=${params.pageSize || 12}&sort=${sort}&searchText=${params.searchText}`;
	const resp = await apiWrapper.get<IGetRegulaionMappingResp, IAPIErrorContent>(
		url,
		{},
	);
	return resp;
};

export const getObligationDetails = async (entityId: string) => {
	const url = `${REG_INV_URL}/group/${entityId}`;
	const resp = await apiWrapper.get<IObligationCard, IAPIErrorContent>(url, {});
	return resp;
};

export const getObligationRelationship = async (
	citationGroupId: string,
	params: IGetObligationRelationshipParams,
) => {
	const url = `${REG_INV_URL}/relationships?citationGroupId=${citationGroupId}&page=${
		params.pageNumber || 0
	}&size=${params.pageSize || 10}&sortField=${params.sortKey || ''}&sortOrder=${
		params.sortDirection || ''
	}`;
	const resp = await apiWrapper.get<IGetRegulaionMappingResp, IAPIErrorContent>(
		url,
		{},
	);
	return resp;
};
export async function getTasksTableData(
	id: string,
	payload: Pagination,
	isHorizonScanModule: boolean,
	searchText?: string,
) {
	const sortKey = payload?.sortKey ? payload?.sortKey : '';
	const sortDirection = payload?.sortDirection ? payload?.sortDirection : '';
	const sort = sortKey !== '' ? `${sortKey},${sortDirection}` : '';
	const parentObjectType = isHorizonScanModule ? 'Horizon' : 'Group';
	const url = `${
		process.env.REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL
	}/task-manager/mapped-task-details?parentObjectId=${id}&parentObjectType=${parentObjectType}&searchText=${
		searchText ?? ''
	}&page=${payload.pageNumber || 0}&size=${payload.pageSize}&sort=${sort}`;
	const res = await apiWrapper.get<ITaskTabResponse, IAPIErrorContent>(url, {});
	return res;
}
export const updateData = async (data: IQueryCriteria) => {
	const url = `${process.env.REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/task-manager/task/search`;
	const resp = await apiWrapper.post<IMappedTaskData, IAPIErrorContent>(
		url,
		data,
	);
	return resp;
};

export const genHorizonAISummary = async (text: string) => {
	const url = `${process.env.REACT_APP_REG_CHANGE_DOMAIN_SERVICE_URL}/injestion/gen-ai-summary`;
	const res = await apiWrapper.post<APIResponse, IAPIErrorContent>(url, text);
	return res;
};

export const getRegeneratedPromptSummary = async (
	promptKey: string,
	originalObligation: string,
	regChanges: string,
) => {
	const url = `${genAiServiceUrl}/prompts/${promptKey}/execute`;
	const res = await apiWrapper.post<APIResponse, IAPIErrorContent>(
		url,
		{
			parameters: {
				original_obligation: originalObligation,
				reg_changes: regChanges,
			},
		},
		JSON,
		getHeader(),
	);
	return res;
};

export const getRegeneratedSummary = async (
	originalObligation: string,
	regChanges: string,
) => {
	const url = `${genAiServiceUrl}/prompts/models/change-summary/execute`;
	const res = await apiWrapper.post<APIResponse, IAPIErrorContent>(
		url,
		{
			parameters: {
				original_obligation: originalObligation,
				reg_changes: regChanges,
			},
			location: HORIZON_SCANNING,
		},
		JSON,
		getHeader(),
	);
	return res;
};

export const generateAIRelMappingCards = async (parentObjectId: string) => {
	const resp = await apiWrapper.post<string | IAPIErrorContent>(
		`${BASE_URL}/injestion/regulation/insight/update-ai-cards`,
		[`${parentObjectId}`],
	);
	return resp;
};

export const updateChangeSummaryText = async (
	parentObjectId: string,
	changeSummary: string,
) => {
	const resp = await apiWrapper.put<string | IAPIErrorContent>(
		`${BASE_URL}/reg-inventory/summary-assessment/plain-language-summary/${parentObjectId}`,
		{ changeSummary },
	);
	return resp;
};
